<div class="progress-cell {{statusValue}}">
    <span>{{params.value}}</span>
</div>
